import React from "react";
import { Text } from "@chakra-ui/react";
export function Pill({ children }) {
    return (React.createElement(Text, { as: "span", fontSize: "md", bg: "gray.200", color: "gray.800", borderRadius: "full", px: 3, py: 1 }, children));
}
